





















































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import UiList from '@superUI/List/List'

settings =
  name: 'DataIntegrity'
  components: { SuperContainerView, UiList }
  resources:
    item:
      resourceName: 'data_integrity'
      slug: 'dev_tools/data_integrity'
  vue:
    computed:
      biqueryOk: ->
        for data in @item.data
          for item in data.counts
            return false unless item.bq_integrity

        return true
      appEventOk: ->
        for data in @item.data
          for item in data.counts
            return false unless item.app_event_integrity

        return true

    methods:
      hiReQueue: ->
         @save("dev_tools/triggers/data_integrity", "data_integrity", {})


export default VueOptions.vue settings
